import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_SCHEME_LIST,
  GET_SCHEMEANALYTE,
  GET_SCHEMENAME,
  ADD_NEW_SCHEME_LIST,
  UPDATE_NEW_SCHEME_LIST,
  DELETE_SCHEME,
  GET_PURCHASED_SCHEME,
  GET_COA_CRITERIA_LIST,
  SUBMIT_COA_PARTICIPANTS,
  GET_COA_SUBMITTED_LIST,
  GET_STOCK_LIST,
  ADD_STOCK,
  UPDATE_STOCK,
} from "./actionTypes";

import {
  addNewSchemeListFail,
  addNewSchemeListSuccess,
  getSchemeAnalyteSuccess,
  getSchemeAnalyteFail,
  getSchemeNameSuccess,
  getSchemeNameFail,
  updateSchemeListSuccess,
  updateSchemeListFail,
  getSchemelistFail,
  getSchemelistSuccess,
  deleteSchemeSuccess,
  deleteSchemeFail,
  getPurchasedSchemelistSuccess,
  getPurchasedSchemelistFail,
  COACriterialistSuccess,
  COACriteriaListFail,
  submitCOAParticipantsSuccess,
  submitCOAParticipantsFail,
  getCOASubmittedListSuccess,
  getCOASubmittedListFail,
  getStockListSuccess,
  getStockListFail,
  addStockSuccess,
  addStockFail,
  updateStockSuccess,
  updateStockFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getSchemelist,
  getSchemeName,
  getSchemeAnalyte,
  updateScheme,
  addNewScheme,
  deleteScheme,
  getPurchasedSchemelistApi,
  COACriterialistApi,
  postCOAParticipants,
  getCOASubmittedParticipantsApi,
  getStockListApi,
  addStockApi,
  updateStockApi,
} from "../../helpers/django_api_helper";

function* fetchSchemeList(object) {
  try {
    const response = yield call(getSchemelist, object.payload);
    console.log("Response from getMethodlist:", response); // Log the response object
    yield put(getSchemelistSuccess(response.data));
  } catch (error) {
    yield put(getSchemelistFail(error));
  }
}
function* fetchSchemeAnalyte(action) {
  try {
    console.log("Fetching scheme analyte with payload:", action.payload);
    const response = yield call(getSchemeAnalyte, action.payload);

    // Log the full response to inspect its structure
    console.log("Saga Full Response:", response);

    // Validate the response structure
    if (
      response.data?.status === "success" &&
      Array.isArray(response.data?.data?.analytes)
    ) {
      // Dispatch action with the analytes data
      yield put({
        type: "GET_SCHEMEANALYTE_SUCCESS",
        payload: response.data.data.analytes,
      });
    } else {
      // Handle unexpected response structure
      yield put({
        type: "GET_SCHEMEANALYTE_FAIL",
        payload: "Unexpected response structure.",
      });
    }
  } catch (error) {
    console.error("Saga Error:", error.message);
    yield put({
      type: "GET_SCHEMEANALYTE_FAIL",
      payload: error.message || "Failed to fetch scheme analyte.",
    });
  }
}

function* fetchSchemeName(object) {
  try {
    const response = yield call(getSchemeName, object.payload);
    yield put(getSchemeNameSuccess(response.data));
  } catch (error) {
    yield put(getSchemeNameFail(error));
  }
}
function* onAddNewScheme(object) {
  try {
    const response = yield call(
      addNewScheme,
      object.payload.createUnit,
      object.payload.id,
    );
    yield put(addNewSchemeListSuccess(response));
  } catch (error) {
    yield put(addNewSchemeListFail(error));
  }
}
function* onUpdateScheme({ payload: unit }) {
  try {
    const response = yield call(updateScheme, unit);
    yield put(updateSchemeListSuccess(response));
  } catch (error) {
    yield put(updateSchemeListFail(error));
  }
}

function* onDeleteScheme({ payload: unit }) {
  try {
    const response = yield call(deleteScheme, unit);
    yield put(deleteSchemeSuccess(response));
  } catch (error) {
    yield put(deleteSchemeFail(error));
  }
}

function* fetchPurchasedSchemeList(object) {
  try {
    const response = yield call(getPurchasedSchemelistApi, object.payload);
    console.log("Response from getPurchasedScheme API:", response);

    // Extract array (adjust this according to your API)
    const schemesArray = Array.isArray(response.payments)
      ? response.payments
      : [];

    yield put(getPurchasedSchemelistSuccess(schemesArray));
  } catch (error) {
    console.error("Error fetching purchased scheme:", error);
    yield put(getPurchasedSchemelistFail(error));
  }
}
function* fetchCOACriterialist(object) {
  try {
    const response = yield call(COACriterialistApi, object.payload);
    console.log("Response from getMethodlist:", response); // Log the response object
    yield put(COACriterialistSuccess(response.data));
  } catch (error) {
    yield put(COACriteriaListFail(error));
  }
}
function* submitCOAParticipantsSaga({ payload }) {
  try {
    const response = yield call(postCOAParticipants, payload);
    yield put(submitCOAParticipantsSuccess(response));
  } catch (error) {
    yield put(submitCOAParticipantsFail(error.message || "Submission failed"));
  }
}
function* fetchCOASubmittedList({ payload }) {
  try {
    const response = yield call(getCOASubmittedParticipantsApi, payload);
    console.log("COA Submitted RAW response:", response.data); // ← ye line add karein
    yield put(getCOASubmittedListSuccess(response.data));
  } catch (error) {
    yield put(getCOASubmittedListFail(error.message));
  }
}
function* fetchStockList({ payload: id }) {
  try {
    const response = yield call(getStockListApi, id);
    yield put(getStockListSuccess(response));
  } catch (error) {
    yield put(getStockListFail(error));
  }
}

function* onAddStock({ payload: { stock, id } }) {
  try {
    const response = yield call(addStockApi, stock, id);
    yield put(addStockSuccess(response));
  } catch (error) {
    yield put(addStockFail(error));
  }
}

function* onUpdateStock({ payload: stock }) {
  try {
    const response = yield call(updateStockApi, stock);
    yield put(updateStockSuccess(response));
  } catch (error) {
    yield put(updateStockFail(error));
  }
}
function* InstrumentTypeListSaga() {
  yield takeEvery(GET_SCHEME_LIST, fetchSchemeList);
  yield takeEvery(GET_COA_CRITERIA_LIST, fetchCOACriterialist);
  yield takeEvery(SUBMIT_COA_PARTICIPANTS, submitCOAParticipantsSaga);
  yield takeEvery(GET_COA_SUBMITTED_LIST, fetchCOASubmittedList);
  yield takeEvery(GET_SCHEMEANALYTE, fetchSchemeAnalyte);
  yield takeEvery(GET_SCHEMENAME, fetchSchemeName);
  yield takeEvery(ADD_NEW_SCHEME_LIST, onAddNewScheme);
  yield takeEvery(UPDATE_NEW_SCHEME_LIST, onUpdateScheme);
  yield takeEvery(DELETE_SCHEME, onDeleteScheme);
  yield takeEvery(GET_PURCHASED_SCHEME, fetchPurchasedSchemeList);
  yield takeEvery(GET_STOCK_LIST, fetchStockList);
  yield takeEvery(ADD_STOCK, onAddStock);
  yield takeEvery(UPDATE_STOCK, onUpdateStock);
}

export default InstrumentTypeListSaga;
